const mod = require('../bahabot.module.js')

export const RESOURCE_TYPE_UNKNOWN = "";
export const RESOURCE_TYPE_EMOTE = "emote";
export const RESOURCE_TYPE_CHANNEL = "channel";
export const RESOURCE_TYPE_GUILD = "guild";
export const RESOURCE_TYPE_MESSAGE = "message";

function isValidId(id) {
    return angular.isDefined(id) && id != "";
}

class DiscordResource {
    primaryType = RESOURCE_TYPE_UNKNOWN;
    primaryValue = "";

    guildId = null;
    channelId = null;
    emoteId = null;
    messageId = null;

    isValid = false;

    constructor() { }

    load(str) {
        const parts = str.split("/");
        if (parts.length < 2 || parts[0] != "guild" || parts[1] == "") {
            this.primaryType = RESOURCE_TYPE_UNKNOWN
            this.isValid = false
            return
        }

        this.guildId = parts[1];

        if (parts.length == 2) {
            this.primaryType = RESOURCE_TYPE_GUILD
            this.isValid = isValidId(this.guildId)
            this.primaryValue = this.guildId;
        } else if (parts.length == 4 && parts[2] == "emote") {
            this.emoteId = parts[3]
            this.primaryType = RESOURCE_TYPE_EMOTE
            this.isValid = isValidId(this.guildId) && isValidId(this.emoteId)
            this.primaryValue = this.emoteId;
        } else if (parts.length == 4 && parts[2] == "channel") {
            this.channelId = parts[3]
            this.primaryType = RESOURCE_TYPE_CHANNEL
            this.isValid = isValidId(this.guildId) && isValidId(this.channelId)
            this.primaryValue = this.channelId;
        } else if (parts.length == 6 && parts[2] == "channel" && parts[4] == "message") {
            this.channelId = parts[3]
            this.messageId = parts[5]
            this.primaryType = RESOURCE_TYPE_MESSAGE
            this.isValid = isValidId(this.guildId) && isValidId(this.channelId) && isValidId(this.messageId)
            this.primaryValue = this.messageId;
        } else if (parts.length == 8 && parts[2] == "channel" && parts[4] == "message" && parts[6] == "thread") {
            this.channelId = parts[3]
            this.messageId = parts[7] // Thread message ID
            this.primaryType = RESOURCE_TYPE_MESSAGE
            this.isValid = isValidId(this.guildId) && isValidId(this.channelId) && isValidId(this.messageId)
            this.primaryValue = this.messageId;
        }
    }
}

DiscordResource.resourceFrom = function(str) {
    const r = new DiscordResource();
    r.load(str);
    return r;
}

/**
 * 
 * @param {angular.resource.IResourceService} $resource 
 * @param {angular.IQService} $q 
 * @returns 
 */
function bahabotDiscordFactory($resource, $q, $http) {
    const ReactionRoles = $resource('/api/protected/discord/reaction-roles', {}, {
        get: { method: 'GET', isArray: true },
        post: { method: 'POST', isArray: true }
    });

    const ClipTargets = $resource('/api/protected/discord/clip-targets', {}, {
        get: { method: 'GET', isArray: true },
        post: { method: 'POST', isArray: true }
    });

    const VideoTargets = $resource('/api/protected/discord/video-targets', {}, {
        get: { method: 'GET', isArray: true },
        post: { method: 'POST', isArray: true }
    });

    const StreamOnlineNotifications = $resource('/api/protected/discord/stream-online-notifications', {}, {
        get: { method: 'GET', isArray: true },
        post: { method: 'POST', isArray: true }
    });

    const XTweetTargets = $resource('/api/protected/discord/x-tweet-targets', {}, {
        get: { method: 'GET', isArray: true },
        post: { method: 'POST', isArray: true }
    });

    const Message = $resource('/api/protected/discord/message/:channelId', {
        'channelId': '@channelId'
    }, {
        post: { method: 'POST', isArray: false }
    })

    return {
        decode: (str) => {
            return DiscordResource.resourceFrom(str);
        },
        ReactionRoles,
        ClipTargets,
        VideoTargets,
        XTweetTargets,
        StreamOnlineNotifications,
        Message,
        fetchRoles: (guildId) => {
            return $http.get('/api/protected/discord/discover/guilds/' + guildId + '/roles').then(res => res.data);
        },
        All: () => {
            return $q.all([
                ReactionRoles.get(),
                ClipTargets.get(),
                VideoTargets.get(),
                XTweetTargets.get(),
                StreamOnlineNotifications.get(),
            ]).then(([roles, clipTargets, videoTargets, xTweetTargets, streamNotifications]) => ({
                roles,
                clipTargets,
                videoTargets,
                xTweetTargets,
                streamNotifications
            }))
        }
    };
}

mod.factory('DiscordService', ["$resource", "$q", "$http", bahabotDiscordFactory]);
